import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Form, Formik } from 'formik';
import { StorageStand } from '../../../models/Storage/StorageStand';
import { StorageRoom } from '../../../models/Storage/StorageRoom';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { ButtonPrimary } from '../../components/Button/ButtonPrimary';
import { ErrorMessageLabel } from '../../components/ErrorMessageLabel/ErrorMessageLabel';
import { InputField } from '../../components/InputField/InputField';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { Select } from 'antd';

function EditStorageStand() {
  const { id } = useParams();
  const navigate = useNavigate();
  const client = useQueryClient();

  // Fetch the stand
  const { data: stand, isLoading: isLoadingStand } = useQuery(
    ['storage-stand', id],
    () => StorageStand.get(Number(id)),
    { enabled: !!id }
  );
  // Fetch all rooms for select
  const { data: rooms = [], isLoading: isLoadingRooms } = useQuery(
    ['storage-rooms'],
    StorageRoom.all
  );

  if (isLoadingStand || isLoadingRooms) return <h1>Loading...</h1>;

  return (
    <>
      <h1 className="cs-title">Izmena skladišne police</h1>
      <Row>
        <Formik
          initialValues={{ name: '', storage_room_id: null }}
          enableReinitialize
          validationSchema={Yup.object({
            name: Yup.string().required('Naziv je obavezan'),
            storage_room_id: Yup.number()
              .nullable()
              .required('Soba je obavezna')
          })}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            stand
              ?.update(values)
              .then(() => {
                client.invalidateQueries(['storage-room-stands']);
                toast.success('Polica izmenjena!');
                navigate('/admin/storage-stands/list');
              })
              .catch((error) => {
                toast.error(
                  error?.response?.data?.message || 'Greška pri izmeni.'
                );
              })
              .finally(() => setSubmitting(false));
          }}
        >
          {({ setFieldValue, isSubmitting, values, errors, touched }) => (
            <Form autoComplete="off" className="cs-form-wrapper">
              <FormGroup>
                <Col lg={6}>
                  <FormLabel>Naziv police</FormLabel>
                  <InputField placeholder="Naziv police" name="name" />
                  <ErrorMessageLabel name="name" />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col lg={6}>
                  <FormLabel>Pripadajuća prostorija</FormLabel>
                  <Select
                    style={{ width: '100%' }}
                    placeholder="Izaberi Prostoriju"
                    value={values.storage_room_id ?? undefined}
                    onChange={(value) =>
                      setFieldValue('storage_room_id', value)
                    }
                    options={rooms.map((room) => ({
                      value: room.id,
                      label: room.name
                    }))}
                    status={
                      errors.storage_room_id && touched.storage_room_id
                        ? 'error'
                        : ''
                    }
                  />
                  <ErrorMessageLabel name="storage_room_id" />
                </Col>
              </FormGroup>
              <ButtonPrimary type="submit" disabled={isSubmitting}>
                Sačuvaj
              </ButtonPrimary>
            </Form>
          )}
        </Formik>
      </Row>
    </>
  );
}

export default EditStorageStand;
